<!--<footer class="pre-footer" *ngIf="footerData && !isEISPage && !isUniHomes">-->
<!--  <div class="content-wrapper">-->
<!--    <h2>{{ footerData.app_heading }}</h2>-->
<!--    <div class="app-container">-->
<!--      <div class="app-description">-->
<!--        <app-render-markdown-->
<!--          [content]="footerData.app_description"-->
<!--        ></app-render-markdown>-->
<!--      </div>-->
<!--      <div class="app-links">-->
<!--        <a-->
<!--          [attr.href]="footerData.apple_store_link"-->
<!--          [attr.target]="footerData.apple_store_link"-->
<!--        >-->
<!--          <img-->
<!--            [attr.src]="footerData.apple_store_image?.data?.attributes?.url"-->
<!--            [attr.alt]="footerData.apple_store_image?.data?.attributes?.name"-->
<!--          />-->
<!--        </a>-->
<!--        <a-->
<!--          [attr.href]="footerData.google_store_link"-->
<!--          [attr.target]="footerData.google_store_link"-->
<!--        >-->
<!--          <img-->
<!--            [attr.src]="footerData.google_store_image?.data?.attributes?.url"-->
<!--            [attr.alt]="footerData.google_store_image?.data?.attributes?.name"-->
<!--          />-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</footer>-->

<footer class="actual-footer" *ngIf="footerData && !isEISPage">
  <div class="content-wrapper">
    <div
      [class.logged-out-footer]="!auth.isAuthenticated()"
      class="footer-cols"
      *ngIf="!isUniHomes"
    >
      <div class="footer-col" id="footer-helpful-links">
        <h3>
          {{ footerData.helpful_links_heading || 'Helpful Links' }}
        </h3>
        <ul *ngIf="!auth.isAuthenticated()">
          <li>
            <a [routerLink]="footerData.logged_out_contact_route">{{
              footerData.logged_out_contact_route_text
            }}</a>
          </li>
        </ul>
        <ul *ngIf="auth.isAuthenticated()">
          <li *ngFor="let link of footerData.helpful_links">
            <app-cms-link [class]="'black'" [link]="link">{{
              link.label
            }}</app-cms-link>
          </li>
        </ul>
      </div>
      <div class="footer-col" id="footer-legal-links">
        <h3>
          {{ footerData.legal_links_heading || 'Legal' }}
        </h3>
        <ul>
          <li *ngFor="let link of footerData.legal_links">
            <app-cms-link [link]="link">{{ link.label }}</app-cms-link>
          </li>
        </ul>
      </div>
      <div class="footer-col footer-e-link">
        <h3 class="endsleigh-link">
          <a href="https://www.howdengroup.com" target="_blank">
            howdengroup.com
          </a>
        </h3>
      </div>
    </div>
    <div class="legal-text">
      <app-render-markdown
        [content]="footerData.legal_text"
      ></app-render-markdown>
    </div>
    <ul class="social-links" *ngIf="footerData.social_links && !isUniHomes">
      <li *ngFor="let socialLink of footerData.social_links">
        <app-cms-link [link]="socialLink">
          <img [src]="socialLink.image?.data?.attributes?.url" />
        </app-cms-link>
      </li>
    </ul>
  </div>
</footer>
